<template>
    <div class="root">
        <div>
          <fieldset v-show="!query.hasOwnProperty('options')">
            <legend>Optimisation Options</legend>

            <div class="form-control">
              <p style="font-weight:bold">Please choose one or more of the following options to proceed</p>
              <button @click.prevent="defaultOptions" class="button-small">Not sure? Click here</button>
              <div>
                <input type="checkbox" :value="true" v-model="maintain" id="maintain">
                <label for="maintain">Maintain Aspect Ratio</label><br/>

                <input type="checkbox" :value="true" v-model="fit" id="fit">
                <label for="fit">Smart Resize & Crop</label>
              </div>
              <br/>
              <label for="width">Width</label>
              <input type="number" v-model="width" id="width">
              <label for="height">Height</label>
              <input type="number" v-model="height" id="height">
              <label for="dpi">DPI (We recommend 75 for the web)</label>
              <input type="number" id="dpi" v-model="dpi">
              <label for="type">Type (We recommend jpeg for the best web compatibility)</label>
              <select id="type" v-model="type">
                <option :value="null">Maintain current image type</option>
                <option value="jpeg">JPEG</option>
                <option value="png">PNG</option>
                <option value="gif">GIF</option>
                <option value="tif">TIF</option>
                <option value="bmp">BMP</option>
                <option value="ico">ICO</option>
                <option value="psd">PSD (Photoshop)</option>
                <option value="webp">WebP</option>
                <option value="data-url">data-url</option>
              </select>
            </div>
          </fieldset>


          <div class="alertBrand" v-if="!query.hasOwnProperty('options')">
            <p>
              <span>Allowed Types: {{ allowed }}, </span> Maximum upload: 200MB Per File
            </p>
          </div>
          <form ref="fileform" enctype="multipart/form-data">
            <label for="fileUploads" class="dropbox-label">
              <div id="dropbox" v-if="(height || width || dpi || type) && !uploading || uploadMore"
                   class="animated fadeIn go">
                <div class="svg-img">
                  <svg fill="red" xmlns="http://www.w3.org/2000/svg" width="100" height="100"
                       viewBox="0 0 24 24">
                    <path
                        d="M12 5c3.453 0 5.891 2.797 5.567 6.78 1.745-.046 4.433.751 4.433 3.72 0 1.93-1.57 3.5-3.5 3.5h-13c-1.93 0-3.5-1.57-3.5-3.5 0-2.797 2.479-3.833 4.433-3.72-.167-4.218 2.208-6.78 5.567-6.78zm0-2c-4.006 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408-.212-3.951-3.473-7.092-7.479-7.092zm4 10h-3v4h-2v-4h-3l4-4 4 4z"/>
                  </svg>
                </div>
                <h5 style="text-transform: uppercase">Drag &amp; drop or click here to upload</h5>
              </div>
              <div class="alertBrand"
                   v-if="query.hasOwnProperty('options') && (height || width || dpi || type) && !uploading">
                <br>
                <br>
                <p>
                  <span>Allowed Types: {{ allowed }}, </span> Maximum upload: 200MB Per File
                </p>
              </div>
              <input id="fileUploads" type="file" multiple v-on:change="addFilesNoDrop($event)" hidden/>
            </label>
          </form>

          <div v-if="files.length" class="animated fadeInUpShort go">
            <div class="popoverInner">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-sm-12">
                    <h2 class="align-center">File Upload</h2>
                    <p class="popupParagraph align-center">Please wait whilst we upload
                      <strong>{{ files.length }} file<span v-if="files.length > 1">s</span>.</strong>
                      This may take a few minutes due to the size of the files.
                    </p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <h5 class="titles">FILE NAME</h5>
                  </div>
                  <div class="col-sm-6">
                    <h5 class="titles">STATUS</h5>
                  </div>
                </div>

                <div v-for="(file, key) in files">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="filename">
                        <p class="multiUploadFileName">{{ file.name }}</p>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="progressContainer">
                        <progress-bar
                            v-if="uploadPercentage[key] !== false && !(uploadPercentage[key] <= 0) && uploadPercentage[key] !== 99 && uploadPercentage[key] !== 100 && !isString(uploadPercentage[key])"
                            :bar-color="color"
                            :val="uploadPercentage[key]"
                            :text="uploadPercentage[key] + '%'"
                            :title="file.name"
                            text-position="inside"
                            text-fg-color="#fff"
                            :key="updateProgress"
                        ></progress-bar>
                        <div class="msg" v-else-if="uploadPercentage[key] <= 0" :key="updateProgress">
                          <p class="statusMessage">Awaiting...</p>
                        </div>
                        <div class="msg" v-else-if="uploadPercentage[key] === 99" :key="updateProgress">
                          <p class="statusMessage">Processing... <span class="spinner"></span></p>
                        </div>
                        <div class="msg" v-else-if="uploadPercentage[key] >= 100">
                          <p class="statusMessage">
                            <button class="button-primary" @click.prevent="download(key)">Download</button>
                          </p>
                        </div>
                        <span class="error" style="color: red" v-else>{{ uploadPercentage[key] }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="align-center return-button" v-if="uploading && !uploadMore">
                <button class="button-primary-outlined" @click.prevent="uploadMore = true">Optimise more images</button>
              </div>
              <div v-if="finished && query.returnto && allowedReferrers.includes(query.returnto)"
                   class="align-center return-button">
                Close tab & return to <a class="button button-primary-outlined" @click.prevent="window.close()">
                {{ query.returnto }}</a>
              </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProgressBar from 'vue-simple-progress'

export default {
  name: "WebifyImage",
  props: {
    query: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  components: {
    'progress-bar': ProgressBar
  },
  data: () => {
    return {
      color: '#3bcbdd',
      allowedReferrers: [
        'Marketbuy',
        'UWebPro',
        'on-offer.co.uk'
      ],
      uploadMore: false,
      fit: false,
      width: null,
      height: null,
      dpi: null,
      type: null,
      maintain: false,
      dragAndDropCapable: false,
      files: [],
      uploadPercentage: [],
      names: {},
      requests: [],
      rules: /\.(jpe?g|png|gif|tif|bmp|ico|psd|ai|webp)$/i,
      allowed: 'JPEG, PNG, GIF, TIF, BMP, ICO, PSD, AI, WebP',
      updateProgress: null,
      uploading: false,
      finished: false,
      window: window
    };
  },
  mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.dragAndDropCapable) {
      this.dragAndDrop()
    }
    for (let key in this.query) {
      this[key] = this.query[key];
    }
    this.color = this.query.returnto === 'Marketbuy' ? '#7ea327' : '#3bcbdd';

    let frameInt = setInterval(() => {
      let $frame = document.querySelector('iframe.goog-te-banner-frame.skiptranslate');
      if ($frame) {
        // console.log($frame);
        // console.log($frame.contentDocument);
        // console.log($frame.contentDocument.head);
        $frame.contentDocument.head.innerHTML = $frame.contentDocument.head.innerHTML
            + '<link rel="stylesheet" href="https://webify-image.com/assets/translate.css" type="text/css">';

        clearInterval(frameInt);
      }
    }, 1000);

    setInterval(() => {
      this.updateProgress++;
    }, 10000)
  },

  methods: {
    defaultOptions() {
      this.width = 1500;
      this.fit = false;
      this.dpi = 75;
      this.maintain = true;
      this.type = 'jpeg';
    },
    dragAndDrop() {
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
          this.$refs.fileform.addEventListener(evt, function (e) {
            e.preventDefault();
            e.stopPropagation();
          }.bind(this), false);
        }.bind(this));
        this.$refs.fileform.addEventListener('drop', function (e) {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.uploadPercentage.push(0);
            this.files.push(e.dataTransfer.files[i]);
          }
          this.submitFiles();
        }.bind(this));
      }
    },
    addFilesNoDrop(event) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.uploadPercentage.push(0);
        this.files.push(event.target.files[i]);
      }
      this.submitFiles();
    },
    determineDragAndDropCapable() {
      let div = document.createElement('div');

      return (('draggable' in div)
          || ('ondragstart' in div && 'ondrop' in div))
          && 'FormData' in window
          && 'FileReader' in window;
    },
    async submitFiles() {
      const iterator = this.files.keys();
      this.uploading = true;
      for (const key of iterator) {
        let file = this.files[key];
        if (this.rules.test(file.name) && !(file.size > 209500000)) {
          let formData = new FormData();
          formData.append('image', file, file.name);
          formData.append('type', this.type);
          formData.append('width', this.width);
          formData.append('height', this.height);
          formData.append('dpi', this.dpi);
          formData.append('fit', this.fit);
          formData.append('maintain_ratio', this.maintain);
          if (!(key % 3) && key >= 2 && !(this.uploadPercentage[key] > 0)) {
            await this.process(formData, key);
          } else if (!(this.uploadPercentage[key] > 0)) {
            this.process(formData, key);
          }
        } else if (file.size > 209500000) {
          this.uploadPercentage[key] = 'Files over 200MB, will not be uploaded';
        } else {
          this.uploadPercentage[key] = 'Incorrect file type, will not be uploaded';
        }
      }
    },

    removeFile(key) {
      if (this.requests[key]) {
        this.requests[key].cancel(`Upload ${key} cancelled`);
      }
      this.files.splice(key, 1);
      this.uploadPercentage.splice(key, 1);
      if (!this.files.length) {
        this.doRemount();
      }
    },

    async process(formData, key) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      this.requests.push(source);
      await axios.post(`/process.php`, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            cancelToken: source.token,
            onUploadProgress: function (progressEvent) {
              let value = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) - 1;
              this.uploadPercentage[key] = value;
              this.updateProgress = value;
            }.bind(this)
          }
      ).then(response => {
        this.uploadPercentage[key] = 100;
        this.names[key] = response.data;
        if (this.uploadPercentage.every((val, i, arr) => val === arr[0])) {
          this.updateProgress = 0;
          this.finished = true;
        }
      });
    },

    download(key) {
      axios({
        url: `/retrieve.php?file=${this.names[key].path}`,
        method: 'GET',
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.names[key].name}.${this.names[key].ext}`);
        document.body.appendChild(link);
        link.click();
      });
    },
    isEmpty(obj) {
      if (obj == null) return true;
      if (obj.length > 0) return false;
      if (obj.length === 0) return true;
      if (typeof obj !== "object") return true;
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }

      return true;
    },
    isString(value) {
      return typeof value === 'string' || value instanceof String;
    },
    doRemount() {
      this.$emit('remount');
    }
  }
    }
</script>

<style scoped>
    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }

    .spinner:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border: 2px solid #ccc;
        border-top-color: #000;
        animation: spinner .6s linear infinite;
    }
</style>
